import { Textarea } from "@/components/ui/textarea";
import { useTranslation } from "react-i18next";
import { useDilemmasFormStore } from "../../stores/useDilemmaFormStore";

const DilemmaReviewComment = () => {
  const { t } = useTranslation();
  const { reviewComment, setReviewComment } = useDilemmasFormStore();

  return (
    <div className="border border-primary p-4 bg-white rounded-md flex flex-col gap-3">
      <div className="flex flex-col">
        <h4 className="font-medium text-sm text-gray-800">
          {t("modules.dilemmas.form.review_comment_title")}
        </h4>
        <p className="text-xs text-gray-400">
          {t("modules.dilemmas.form.review_comment_description")}
        </p>
      </div>
      <Textarea
        className="min-h-32"
        value={reviewComment}
        onChange={(e) => setReviewComment(e.target.value)}
      />
    </div>
  );
};

export default DilemmaReviewComment;
